import React from 'react';
import styled from 'styled-components';

import Box from './Box';
import Flex from './Flex';
import Text from './Text';
import { colors } from '@styles/theme';
import toInt from '@lib/toInt';

const thumbStyles = `
  appearance: none;
  height: 16px;
  width: 16px;
  border-radius: 9999px;
  background: ${colors.primary};
  cursor: pointer;
`;

const trackStyles = `
  width: 100%;
  height: 8px;
  cursor: pointer;
  background: ${colors.grayscale.lightGray};
  border-radius: 4px;
`;

const RangeInput = styled.input`
  // RESETS
  appearance: none; /* Hides the slider so that custom slider can be made */
  width: 100%; /* Specific width is required for Firefox. */
  background: transparent; /* Otherwise white in Chrome */
  outline: none;
  &::-webkit-slider-thumb {
    appearance: none;
  }
  &::-ms-track {
    width: 100%;
    cursor: pointer;

    /* Hides the slider so custom styles can be added */
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  // STYLES

  // thumb styles for chrome, firefox, and IE handles
  &::-webkit-slider-thumb {
    ${thumbStyles};
    // You need to specify a margin in Chrome
    margin-top: -4px;
  }
  &::-moz-range-thumb {
    ${thumbStyles};
  }
  &::-ms-thumb {
    ${thumbStyles};
  }

  // track styles for chrome, firefox, and IE handles
  &::-webkit-slider-runnable-track {
    ${trackStyles};
  }
  &::-moz-range-track {
    ${trackStyles};
  }
  &::-ms-track {
    ${trackStyles};
  }
`;

export default class Slider extends React.Component {
  render() {
    const {
      hideCaption,
      min = 0,
      max = 100,
      step = 5,
      labels = [],
      labelPosition = 'bottom',
      title,
      onChange,
      value: propsValue
    } = this.props;
    const value = toInt(propsValue) !== propsValue ? max / 2 : propsValue;
    let adjustment = value > 5 ? '- 16px' : '';
    adjustment = value > 95 ? '- 32px' : adjustment;
    const left = `calc(${value}% ${adjustment})`;
    const labelsMarkup = (
      <Flex justifyContent="space-between" alignItems="center">
        {labels.map((label, i) => (
          <Text.caption
            key={i}
            mt={labelPosition === 'top' ? 0 : 4}
            mb={labelPosition === 'bottom' ? 0 : 4}
            textAlign={i === 0 ? 'left' : 'right'}
          >
            {label}
          </Text.caption>
        ))}
      </Flex>
    );

    return (
      <Box>
        <Text.body as="p" mb={4}>
          {title}
        </Text.body>
        {labelPosition === 'top' ? labelsMarkup : null}
        <RangeInput
          type="range"
          min={min}
          max={max}
          step={step}
          onChange={onChange}
          onClick={e => e.stopPropagation()}
          value={value}
        />
        {!hideCaption && (
          <Box>
            <Box position="absolute" top="0" left={left}>
              <Text.caption>
                {value}
                &nbsp;/&nbsp;
                {100 - value}
              </Text.caption>
            </Box>
          </Box>
        )}
        {labelPosition === 'bottom' ? labelsMarkup : null}
      </Box>
    );
  }
}
